// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Haptic_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M15 3H9a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 9 21h6a2.25 2.25 0 0 0 2.25-2.25V5.25A2.25 2.25 0 0 0 15 3Zm.75 15.75a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75V5.25A.75.75 0 0 1 9 4.5h6a.75.75 0 0 1 .75.75Zm4.5-10.5v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 1.5 0Zm3 1.5v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 1.5 0Zm-18-1.5v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 1.5 0Zm-3 1.5v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 1.5 0Z',
  viewBox: '0 0 24 24',
  glyph: 'Haptic_Stroke2_Corner2_Rounded',
})
